import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(DialogContent)(() => ({
  paddingBottom: '100px'
}));

export const NoteStyled = styled('div')(({ theme }) => ({
  padding: '16px',
  borderRadius: '16px',
  backgroundColor: theme.palette.background.blue.main
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));

export const CapturedImageWrapperStyled = styled(Stack)(({ isDisable }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  opacity: isDisable ? 0.5 : 1
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  margin: '0 !important'
}));

export const SectionWrapperStyled = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '16px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px'
}));

export const MoneyWrapperStyled = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '16px',
  padding: '16px 24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  position: 'relative'
}));

export const ChipStyled = styled('div')(({ theme, backgroundColor, color }) => ({
  ...theme.typography.xs,
  backgroundColor,
  color,
  borderRadius: '16px',
  padding: '4px 10px'
}));
